import * as React from 'react';
import { ToggleCard } from '../../procedures/components';
import { ChildContent, List, Title } from './styled';

interface TogglePaymentOptionsProps {
  image?: string;
  title: string;
  list: any;
  childContent: any;
}
const TogglePaymentOptions = ({
  image,
  title,
  list,
  childContent
}: TogglePaymentOptionsProps) => (
  <ToggleCard isPayment isMigrated>
    <Title>
      <img src={image} alt="iconSmartphone" />
      <span>{title}</span>
    </Title>
    <List>
      <ul>
        {list.map((item: { title?: string; content: string }) => (
          <li key={item.content}>
            {item.title && (
              <span>
                <strong>{item.title}</strong>
              </span>
            )}
            <span>{item.content}</span>
          </li>
        ))}
      </ul>
    </List>
    <ChildContent>{childContent}</ChildContent>
  </ToggleCard>
);

export { TogglePaymentOptions };
